import OptionsGetter from './OptionsGetter.vue';

export default OptionsGetter;
